import { useDataContext } from "../context/DataContext";

const SUPERVISOR_LABEL = "Supervisor";
const PERSONNEL_LABEL = "Personnel";

// Stroke icons drawn like the other shell icons. One person is personnel; two people is a supervisor.
function PersonnelIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  );
}

function SupervisorIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  );
}

/** Whose view this is: a role icon and "Welcome, Firstname Lastname" from Rapid Crews, for the person whose data is shown. */
export default function UserBadge() {
  const { currentPersonnelId, personnelFullNameMap, isSupervisor } = useDataContext();
  const name = personnelFullNameMap.get(currentPersonnelId);
  const role = isSupervisor ? SUPERVISOR_LABEL : PERSONNEL_LABEL;

  return (
    <div className="user-badge" title={name ? `${name} (${role})` : role}>
      <span className="user-badge__icon" role="img" aria-label={role}>
        {isSupervisor ? <SupervisorIcon /> : <PersonnelIcon />}
      </span>
      {name && <span className="user-badge__name">Welcome, {name}</span>}
    </div>
  );
}
